/**
 * @generated SignedSource<<de99084378b2ca0574d939c3861e0671>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type RecordingMediaType = "AUDIO" | "VIDEO";
import { FragmentRefs } from "relay-runtime";
export type Video_meetingRecording$data = {
  readonly __typename: string;
  readonly activeSummary?: {
    readonly chapters: ReadonlyArray<{
      readonly bulletPoints: ReadonlyArray<{
        readonly context: string | null;
        readonly text: string;
        readonly textShort: string | null;
        readonly timestamp: number | null;
      }>;
      readonly timestamp: number | null;
      readonly title: string;
    }> | null;
  } | null;
  readonly aiArtifactsTxtDownloadUrl?: string | null;
  readonly createdAt: string;
  readonly id: string;
  readonly isFavourite: boolean;
  readonly mediaType: RecordingMediaType;
  readonly meetingCallEnd?: string | null;
  readonly meetingRecordedVideoPosterUrl: string | null;
  readonly meetingRecordedVideoUrl: string | null;
  readonly transcriptTxtDownloadUrl: string | null;
  readonly viewCount: number | null;
  readonly " $fragmentSpreads": FragmentRefs<"Timeline_meetingKeyEvents">;
  readonly " $fragmentType": "Video_meetingRecording";
};
export type Video_meetingRecording$key = {
  readonly " $data"?: Video_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"Video_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "timestamp",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Video_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isFavourite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "transcriptTxtDownloadUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "meetingRecordedVideoPosterUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaType",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "meetingCallEnd",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "aiArtifactsTxtDownloadUrl",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MeetingRecordingSummary",
          "kind": "LinkedField",
          "name": "activeSummary",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "TranscriptChapter",
              "kind": "LinkedField",
              "name": "chapters",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "TranscriptBulletPoint",
                  "kind": "LinkedField",
                  "name": "bulletPoints",
                  "plural": true,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "text",
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "textShort",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "context",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Timeline_meetingKeyEvents"
        }
      ],
      "type": "MeetingRecording",
      "abstractKey": null
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
};
})();

(node as any).hash = "83e5bfe26a04670fe819aa9026d20a48";

export default node;
